import React,{useEffect,useState} from 'react';
import { Container, Row,Col } from 'reactstrap';
import './styles/App.css';
import DriveInfo from './DriveInfo'
import axios from 'axios';
import { instance } from './common';

function DrawInfo({goPage,history}) {

    const myinfo = JSON.parse(window.sessionStorage.result);
    const { u_login_id,u_nick,u_type,u_dealer_agency } = myinfo;
    let field;
    let represent;    
    if(u_type == '일반고객'){
        field = 'c.co_user_id';
        represent = 'rep.represent';
    }else if(u_type == '카마스터'){
        field = 'c.co_user_id2';
        represent = 'rep.represent2';
    }
    const [data, setData] = useState([]);
    const [data2, setData2] = useState('-');
    let obj = {
        u_id:u_login_id,
        field:field,
        represent:represent
    }
    useEffect(() => {
        
      const fetchData = async () => {
        instance.post('/rep_car/main_info',obj).then(function(res){
            setData(res.data);
        });
 
      };

      fetchData();

    }, []);

    console.log('data2 : ', data2)

    const mySize = {
        marginTop: "30px",
        marginBottom: "30px"
    }

    return (
        
        <Container style={mySize}>
            {
                data.length !== 0
                ?
                data.map(v => <Row key={v.rep_id}>
                    <Col className="p-0">
                        <div className="r_flex position-relactive">
                            <h3 className="font-weight-bold mb-3">차량정보</h3>
                        </div>
    
                        <table className="table table-borderless mb-3 table_font_mobile">
                            <thead></thead>
                            <tbody>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">모델명</th>
                                    <td>{v.u_car_name}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량번호</th>
                                    <td>
                                        {
                                        u_type == '일반고객'
                                        ?v.u_car_number
                                        :<span>-</span>
                                        }
                                    </td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량 APP 등록일</th>
                                    <td>{v.u_app_date}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">연식</th>
                                    <td>{v.u_car_age}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고일</th>
                                    <td>{v.u_car_date}</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고색상</th>
                                    <td>{v.u_car_color}</td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
    
                    </Col>
                </Row>)
                :
                <Row>
                    <Col className="p-0">
                        <div className="r_flex position-relactive">
                            <h3 className="font-weight-bold mb-3">차량정보</h3>
                        </div>
    
                        <table className="table table-borderless mb-3 table_font_mobile">
                            <thead></thead>
                            <tbody>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">모델명</th>
                                    <td><span>-</span></td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량번호</th>
                                    <td>
                                        {
                                        u_type == '일반고객'
                                        ?<span>-</span>
                                        :<span>-</span>
                                        }
                                    </td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">차량 APP 등록일</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">연식</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고일</th>
                                    <td>-</td>
                                </tr>
                                <tr className="noneBorder">
                                    <th className="text-lightgray">출고색상</th>
                                    <td>-</td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
    
                    </Col>
                </Row>
            }
            
        </Container>
    )
}

function Progress() {

    const myinfo = JSON.parse(window.sessionStorage.result);
    // console.log('myinfo  : ', myinfo);
    const { u_login_id,u_car_name, u_car_number, u_car_date,u_type } = myinfo;
    const obj = myinfo;
    //loadReseve(u_car_number);

    const [data, setData] = useState([]);

    const [before, setBefore] = useState([]);
    const [after, setAfter] = useState([]);

    useEffect(() => {
        let u_field;
        let rep_field;
        if(u_type == '카마스터'){
            u_field = 'u_id2';
            rep_field = 'represent2';
        }else if(u_type == '일반고객'){
            u_field = 'u_id';
            rep_field = 'represent';
        }
        let obj = {
            u_field:u_field,
            u_id:u_login_id,
            rep_field:rep_field,
        }
        const fetchData = async () => {
            instance.post('/rep_car/status',obj).then(function(res){
              console.log('res : ', )
              setData(res.data[0]);
              if(res.data.length !==0){
                setBefore(JSON.parse(res.data[0].photo_before))
                setAfter(JSON.parse(res.data[0].photo_after))
              }
           
          });
   
        };
  
        fetchData();
  
      }, []);

      console.log('data : ', data)

      const circle = {
          width:'8px',
          height:'8px',
          borderRadius:'90px',
          position:'absolute',
          background:'#ddd',
          left:'-3px'
      }

      const second = {
        top:'100px'    
    }
    const third = {
        top:'286px'    
    }

    const blueBg = {
        background:'#06f'
    }

    const variWidth = {
        //height: data.r_enddate ? '290px' :  data.r_gumsu ? '100px' : '0px'
        
    }
    return (
        <>
            <DrawInfo />
            {
                data
                ?
                <Container className="p_boxshadow">
                <Row className="d-block" style={{marginBottom: '30px'}}>
                    <div className="p_wrapLine">
                    
                        <div className="wrap_status" id="statusbar" style={{background:'#ddd'}}>
                        {!data.r_ipgo ? <span style={circle}></span> : <span style={{...circle,...blueBg}}></span>}
                        {!data.r_gumsu ? <span style={{...circle,...second}}></span> :<span style={{...circle,...second,...blueBg}}></span>}
                        {!data.r_enddate ? <span style={{...circle,...third}}></span> :<span style={{...circle,...third,...blueBg}}></span>}        
                        </div>
                        <div className="statusbarAtive" id="" style={{background:'#06f',...variWidth}}></div>
                        <div>
                            <h3 className="font-weight-bold mt-5 mb-4">진행상태</h3>
                            <div>
                                <h4 className="font-weight-bold mb-0 ml-4" id="start">{!data.r_ipgo ? <span>차량입고</span> :<span>차량입고 완료</span>}</h4>
                                <span className="text-muted ml-4" id="reserve_complete">{data.r_ipgo}</span>
                                <span className="text-muted" id="start2"> </span>
                            </div>
                            <h4 className="font-weight-bold mb-0 ml-4 p_midSection" id="check">{!data.r_gumsu ? <span>검수</span> :<span>검수 완료</span>}</h4>
                            <span className="text-muted ml-4" id="gumsu_complete">{data.r_gumsu}</span>
                            <span className="text-muted" id="check2"> </span>
                            <div className="div-overflow-wrap">
                                <div className="p_wrapMid ml-4 mt-3">
                                    {
                                        before.length !=0
                                        ?
                                        before.map(v => <div className="p_midimg mr-4" style={{background:'url(\''+v+'\')'}}></div>)
                                        :<div></div>
                                    }        
                                </div>
                            </div>
                            <h4 className="font-weight-bold mb-0 ml-4 p_botSection" id="finish">{!data.r_enddate ? <span>작업</span> :<span>작업 완료</span>}</h4>
                            <span className="text-muted ml-4" id="work_complete">{data.r_enddate}</span>
                            <span className="text-muted" id="finish2"> </span>
                        </div>
                    </div>
                </Row>
            </Container>
            :
            <Container className="p_boxshadow">
                <Row className="d-block" style={{marginBottom: '30px'}}>
                    <div className="p_wrapLine">
                    
                        <div className="wrap_status" id="statusbar" style={{background:'#ddd'}}>
                        <span style={{...circle}}></span>
                        <span style={{...circle,...second}}></span>
                        <span style={{...circle,...third}}></span>    
                        </div>
                        <div className="statusbarAtive" id="" style={{background:'#06f',...variWidth}}></div>
                        <div>
                            <h3 className="font-weight-bold mt-5 mb-4">진행상태</h3>
                            <div>
                                <h4 className="font-weight-bold mb-0 ml-4" id="start"><span>차량입고</span></h4>
                                <span className="text-muted ml-4" id="reserve_complete"></span>
                                <span className="text-muted" id="start2"> </span>
                            </div>
                            <h4 className="font-weight-bold mb-0 ml-4 p_midSection" id="check"><span>검수</span></h4>
                            <span className="text-muted ml-4" id="gumsu_complete"></span>
                            <span className="text-muted" id="check2"> </span>
                            <div className="div-overflow-wrap">
                                <div className="p_wrapMid ml-4 mt-3">  
                                </div>
                            </div>
                            <h4 className="font-weight-bold mb-0 ml-4 p_botSection" id="finish"><span>작업</span> </h4>
                            <span className="text-muted ml-4" id="work_complete"></span>
                            <span className="text-muted" id="finish2"> </span>
                        </div>
                    </div>
                </Row>
            </Container>
            }
            
        </>
    );
}

function loadReseve(r_car_number) {
    instance.post('/reserve/same-number', {
        r_car_number: r_car_number
    })
        .then(function (response) {
            // handle success
            const data = response.data;

            if (data.length !== 0) {
                let str = '';
                data.forEach(v => {
                    console.log("v.r_status : ", v.r_status);
                    if (v.r_status == '입고완료') {
                        document.getElementById('reserve_complete').innerHTML = v.r_reserve_date;
                        document.getElementById('start').innerHTML = ' ' + v.r_status;
                        document.getElementById('start2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:10% " aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    } else if (v.r_status == '검수완료') {
                        document.getElementById('gumsu_complete').innerHTML = v.r_gumsu;
                        document.getElementById('check').innerHTML = ' ' + v.r_status;
                        document.getElementById('check2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:50% " aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    } else if (v.r_status == '작업완료') {
                        document.getElementById('work_complete').innerHTML = v.r_enddate;
                        document.getElementById('finish').innerHTML = v.r_status;
                        document.getElementById('finish2').innerHTML = ' ' + v.r_status;
                        str += '<div class="progress">\
                        <div class="progress-bar" role="progressbar" style="width: 100%; height:100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>\
                      </div>';
                    }
                    
                    document.getElementById('statusbar').innerHTML = str;
                   
                });


            }
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
}

export default Progress;